module.exports = "https://trybtryb-legacy.web.app/img/ellen_kathryn_pumpkin.06786d06.webp";